<template>
  <div class="sip_game_w" :data-speed="speed" >
    <!-- <div ref="game" class="sip-game" /> -->
    <canvas ref="game" class="sip_game" />
    <!-- <div v-if="$isMob" class="sip_mob_actions">
      <div class="sip_mob_actions_left" @click="onUp" />
      <div class="sip_mob_actions_right" @click="onDown" />
    </div> -->
    <div class="sip_top" ref="timerTop" data-active="">
      <Timer :timer="timerStr" />
      <div class="sip_top_text">Заправка</div>
    </div>
    <div v-if="!$isMob" class="sip_ui">
      <Status
        :score="score"
        :id="score"
        @clicked="onModal"
        @clickAbout="$modal.show('main-modal-about')"
      />
      <div class="sip_space" data-size="2" />
      <Notification :notify="notify" />
      <div class="sip_space" data-size="1" />
      <Controls :speed="speed" @clicked="onUpDown" />
    </div>

    <div v-if="$isMob" class="sip_header_mob">
      <div class="sip_title_mob">
        <img :srcset="`${$server}logo_mob.png 1x, ${$server}logo_mob_2x.png 2x`" :src="`${$server}logo_mob.png`" />
      </div>
      <div class="sip_btn sip_btn_about" @click="$modal.show('main-modal-about')">
        <span>Справка</span>
      </div>
      <div @click="$modal.show('main-modal-help')" class="sip_status_help">
        Правила
        <div class="sip_status_help_icon">i</div>
      </div>      
    </div>

    <div v-if="$isMob" class="sip_ui">
      <Notification :notify="notify" />
      <ControlsMob :speed="speed" @clicked="onUpDown" :timer="timerStr" @refill="onRefill" ref="Status" />
    </div>

    <modal name="main-modal"
      transition="modal"
      width="auto"
      height="auto"
      @closed="modalClosed"
      @opened="modalOpened"
      @before-close="modalBeforeClose"
      :data-modal="modalContent.id"
      :clickToClose="false"
    >
      <div class="sip_modal_title" v-html="modalContent.title" />

      <div class="sip_modal_body_w" >
        
        <div v-if="!short" @click="onShort(modalContent.id)" v-html="`${modalContent.short} <span>Подробнее...</span>`" class="sip_modal_body_short" />
        <div v-if="short">
        <div v-html="modalContent.text" class="sip_modal_body" />
        <div v-if="!$isMob">
          <div v-if="modalContent.img" v-for="(img, i) of modalContent.img" :key="img">
            <img :src="`${$server}${img}`" class="sip_modal_img" :data-img="i" />
          </div>
        </div>
        <div v-if="$isMob">
          <div v-if="modalContent.img" v-for="(img, i) of modalContent.imgMob" :key="img">
            <img :src="`${$server}${img}`" class="sip_modal_img" :data-img="i" />
          </div>
        </div>
        </div>
        
      </div>

      <div class="sip_modal_fade" />
      <div @click="pers === -100 ? $modal.hide('main-modal'): null" class="sip_modal_btn_space">
        закрыть <span />
        <BtnProgress :pers="pers" v-if="pers > -100" />
      </div>
    </modal>

    <modal name="main-modal-help" transition="modal" width="auto" height="auto" @closed="modalClosed" @opened="modalOpened" @before-close="modalBeforeClose" >
      <div ref="modal_body" class="sip_modal_help sip_modal_body_w">
        
        <div class="sip_modal_body">

          <div class="sip_modal_title2">Добро пожаловать на борт первого в России СПГ-бункеровщика «Дмитрий Менделеев»!</div>
          <div>
            Вам предстоит заправить экологичным природным газом разные суда, чтобы они снова смогли выйти на маршрут. Если все получится — станете капитаном.
            <div class="sip_divide_text"><span>Цель игры</span></div>
            <div>
              Ваша задача — правильно рассчитать скорость и остановиться в выделенной зоне рядом с кораблем. Не забывайте про инерцию — судно моментально остановить нельзя. Итоговый результат будет зависеть от времени прохождения игры. Оно не учитывает заправку кораблей — только движение и швартовку.
              <br/><br/>
              Но сохраняйте внимательность! Пока не все суда перешли на экологичное топливо, так что кому-то СПГ может не подойти.
            </div>
            <div class="sip_divide_text"><span>Управление</span></div>
            <div>
              Вы можете управлять кораблем при помощи кнопок на клавиатуре
              <div class="sip_btn_list">

                <div class="sip_flex">
                  <div class="sip_flex sip_flex_center sip_mr45">
                    <div class="sip_btn_arrow">
                      <img :src="`${$server}modal/btn_arrow_up.svg`" />
                    </div>
                    <div>
                      ↑ — вперед
                    </div>
                  </div>

                  <div class="sip_flex sip_flex_center">
                    <div class="sip_btn_arrow">
                      <img :src="`${$server}modal/btn_arrow_down.svg`" />
                    </div>
                    <div>
                      ↓ — назад
                    </div>
                  </div>
                </div>

                <div class="sip_flex sip_flex_center sip_mt15">
                  <div class="sip_btn_arrow">
                    <img :src="`${$server}modal/btn_space.svg`" />
                  </div>
                  <div>
                    ᆫ (пробел) — закрыть всплывающее окно
                  </div>
                </div>

              </div>

            </div>
            <div class="sip_divide_text"><span>Ранги/достижения</span></div>

              <div class="sip_flex sip_flex_space sip_w3_w">
                <div class="sip_w3">
                  <img :srcset="`${$server}modal/rang1.png 1x, ${$server}modal/rang1_2x.png 2x`" :src="`${$server}modal/rang1.png`" />
                  <div>
                    <div class="sip_w3_title">Капитан</div>
                    <div class="sip_w3_small">необходимое время</div>
                    <div>до 2 мин.</div>
                  </div>
                </div>
                <div class="sip_w3">
                  <img :srcset="`${$server}modal/rang2.png 1x, ${$server}modal/rang2_2x.png 2x`" :src="`${$server}modal/rang2.png`" />
                  <div>
                    <div class="sip_w3_title">3-й помощник капитана</div>
                    <div class="sip_w3_small">необходимое время</div>
                    <div>2-4 мин.</div>
                  </div>
                </div>
                <div class="sip_w3">
                  <img :srcset="`${$server}modal/rang3.png 1x, ${$server}modal/rang3_2x.png 2x`" :src="`${$server}modal/rang3.png`" />
                  <div>
                    <div class="sip_w3_title">Боцман</div>
                    <div class="sip_w3_small">необходимое время</div>
                    <div>от 4 мин.</div>
                  </div>
                </div>
              </div>

          </div>
        </div>

      </div>
      <div class="sip_modal_fade" />
      <div @click="$modal.hide('main-modal-help')" class="sip_modal_btn_space">В плавание! <span /></div>

    </modal>


    <modal name="main-modal-result" transition="modal" width="auto" height="auto" :clickToClose="false" @opened="modalOpened" >
      <div class="sip_result_body_w">
      <div class="sip_modal_result sip_flex sip_flex_space">
        
        <div class="sip_result_c1">
          <img :srcset="`${$server}result${resultId}.png 1x, ${$server}result${resultId}_2x.png 2x`" :src="`${$server}result${resultId}.png`" />
        </div>
        <div class="sip_result_c2">
          <div class="sip_modal_title" >Поздравляем!</div>

          <div>

            <div class="sip_modal_body" >

                <div v-html="resultBody" />
                <div class="sip_result_space_s" />
                Ваше время:
                <br/>
                <div class="sip_selected">{{timerStr}}</div>
                <div class="sip_result_space_s" />
                Ваше звание:
                <br/>
                <div class="sip_selected">{{resultTitle}}</div>
              </div>

          </div>




        </div>


        </div>


        <div class="sip_result_footer">
          <div class="sip_divide" />
          <div class="sip_flex sip_flex_space_between">
            <Share :body="resultBody" :id="resultId" />
            <div class="sip_btn" @click="onReload">
              <span>Играть заново</span>
            </div>
          </div>
        </div>

      </div>

      <div class="sip_modal_copy">
        <div>Совместный проект МИА «Россия сегодня» и ПАО «Газпром нефть»</div>
        <div>2021 год</div>
      </div>

    </modal>

    <modal name="main-modal-about" transition="modal" width="auto" height="auto" @closed="modalClosed" @opened="modalOpened">
      <div class="sip_modal_body_w main-modal-about">
        <div v-for="(item, id) of data" :key="id" class="sip_modal_about_item">

          <div>
            <div class="sip_modal_title" v-html="item.title" />

            <div v-html="item.text" class="sip_modal_body" />

            <div v-if="!$isMob">
              <div v-if="item.img" v-for="(img, i) of item.img" :key="img">
                <img :src="`${$server}${img}`" class="sip_modal_img" :data-img="`${id}-${i}`" />
              </div>
            </div>
            <div v-if="$isMob">
              <div v-if="item.img" v-for="(img, i) of item.imgMob" :key="img">
                <img :src="`${$server}${img}`" class="sip_modal_img" :data-img="`${id}-${i}`" />
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="sip_modal_fade" />
      <div @click="$modal.hide('main-modal-about')" class="sip_modal_btn_space">закрыть <span /></div>

    </modal>

    <!-- <div class="sip_debug">
      <div>{{yPos}}</div>
      <div>{{debug.h1}}</div>
      <div>{{debug.h2}}</div>
    </div> -->

    <div class="sip_canvas_preloader" ref="preloader">
      <Start :progress="progress" @clicked="onLoaded" />
    </div>

  </div>
</template>

<script>
import * as PIXI from 'pixi.js'
import _throttle from 'lodash/throttle'
import Start from './Start'
import Controls from '@/components/Controls.vue'
import ControlsMob from '@/components/ControlsMob.vue'
import Notification from '@/components/Notification.vue'
import Status from '@/components/Status.vue'
import Timer from '@/components/Timer.vue'
import BtnProgress from '@/components/BtnProgress.vue'
import Share from '@/components/Share.vue'
import { data } from '../../data.js'
// import { settings } from 'pixi.js'
import { Debug } from './debug'
import { connect, post, event } from '../gtm.js'

window.app = {}
window.app.projectName = "gpn-game";
window.app.version = "d";

const debug = new Debug();

const timeCounterRev = (str) => {
  let arr = str.split(':')
  return (+arr[0]) * 60 * 60 + (+arr[1]) * 60 + (+arr[2])
};

const timeCounter = _throttle((num) => {
  let hours   = Math.floor(num / 3600);
  let minutes = Math.floor((num - (hours * 3600)) / 60);
  let seconds = Math.round(num - (hours * 3600) - (minutes * 60));
  hours = hours < 10 ? `0${hours}`: `${hours}`
  minutes = minutes < 10 ? `0${minutes}`: `${minutes}`
  seconds = seconds < 10 ? `0${seconds}`: `${seconds}`
  return `${hours}:${minutes}:${seconds}`;
}, 100);

export default {
  name: 'Game',
  data() {
    return {
      progress: 0,
      short: false,
      pers: -100,
      data,
      notify: 0,
      speed: 0,
      speedLast: 0,
      moving: true,
      speedMax: 3,
      speedMin: -2,
      stoped: false,
      score: 0,
      id: 1,
      lock: false,
      lockTotal: false,
      width: 1920,
      height: 1080,
      scale: 0.3,
      areaContainer: null,
      pierContainer: null,
      shipsContainer: null,
      refuellerContainer: null,
      bgElContainer: null,
      sledBackward: null,
      sledForward: null,
      fishContainer: null,
      timer: 0,
      timerStr: '00:00:00',
      finish: false,
      resultTitle: 'Боцман',
      resultBody: 'Вы&nbsp;заправили все суда СПГ. Ходить на&nbsp;бункеровщике&nbsp;&mdash; задача непростая.',
      resultId: '1',
      // yPos: 0,
      // debug: {
      //   h1: 0,
      //   h2: 0
      // },
      refillDone: false,
      modalOpen: false,
      modalContent: {
        title: ``,
        text: ``,
        short: ``,
      }
    }
  },
  components: {
    Status,
    Notification,
    Controls,
    ControlsMob,
    BtnProgress,
    Timer,
    Share,
    Start,
  },
  watch: {
    speed() {
      this.refuellerContainer.ladder.alpha = 0
    },
  },
  mounted() {
    connect(app)
    event('entrance')

    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.init();
    this.keyEvents();

    this.modalContent = data[`s1`];
    this.modalContent.id = `s1`;
    // this.$modal.show('main-modal');
    // this.$modal.show('main-modal-help');
    // setTimeout(() => {
    //   console.log('init');
    //   Sharer.init();
    // }, 4000);
    // setTimeout(() => {
    //   this.$modal.show('main-modal-result');  
    // }, 2000);
    this.lock = true
  },
  methods: {
    onLoaded() {
      this.$refs.preloader.classList.add('sip_canvas_preloader_loaded')
      this.$modal.show('main-modal-help')
      setTimeout(() => {
        this.$refs.preloader.style.display = "none"
      }, 300);
    },
    onShort() {
      event('inner_link', {inner_link: `modal-full-${this.modalContent.id}`});
      this.short = true
    },
    onReload() {
      window.location.reload(false)
    },
    completed(id){
      this.score++
      this.lock = true
      setTimeout( () => {
        this.onModal(id)
      }, 300);
    },
    modalOpened(el) {
      // Analitycs
      if(el.name === 'main-modal-help') {
        event('inner_link', { inner_link: `modal-help`});
      }
      if(el.name === 'main-modal-about') {
        event('inner_link', { inner_link: `modal-about`});
      }
      if(el.name === 'main-modal') {
        event('inner_link', { inner_link: `modal-short-${this.modalContent.id}` });
      }
      if(el.name === 'main-modal-result') {
        event('inner_link', { inner_link: `modal-result-${this.resultId}` });
      }
      // console.log('opened', el.name);
      //  -----------
      if(el.name === 'main-modal-about' || el.name === 'main-modal-help') {
        this.speed = 0
        this.lock = true
        this.moving = false
        this.stoped = true
      }
      this.modalOpen = true;
    },
    modalClosed(el) {
      this.modalOpen = false;
      this.short = false;
      if(el.name === 'main-modal-about' || el.name === 'main-modal-help') {
        console.log('closed', el.name);
        this.lock = false
        this.moving = true
        this.stoped = false
        return
      }
      
      this.moving = true
      this.stoped = false;
      if(this.score === 6) { // 6
        this.finish = true
        this.lock = true
        this.moving = false
        this.stoped = true
        // ----
        // this.timer = timeCounterRev('02:18:00');
        // this.timerStr = timeCounter(this.timer)
        // console.log(this.timerStr, this.timer);
        // ----
        if(this.timer >= timeCounterRev('04:00:00')) {
          this.resultTitle = 'Боцман'
          this.resultId = '1'
          this.resultBody = 'Вы&nbsp;заправили все суда СПГ. Ходить на&nbsp;бункеровщике&nbsp;&mdash; задача непростая.'
        }else if(this.timer < timeCounterRev('04:00:00') && this.timer > timeCounterRev('02:00:00')) {
          this.resultTitle = '3-й помощник капитана'
          this.resultId = '2'
          this.resultBody = 'Вы&nbsp;заправили все суда СПГ. Когда-нибудь и&nbsp;вы&nbsp;станете главным на&nbsp;бункеровщике.'
        }else if(this.timer <= timeCounterRev('02:00:00')) {
          this.resultTitle = 'Капитан'
          this.resultId = '3'
          this.resultBody = 'Вы&nbsp;блестяще справились с&nbsp;задачей, заправив все суда СПГ.'
        }
        console.log(this.timerStr, this.timer);
        setTimeout(() => {
          this.$modal.show('main-modal-result');  
        }, 1000);
        setTimeout(() => {
          Sharer.init();
        }, 3000);
      }
    },
    modalBeforeClose(modal) {
      if(modal.name === 'main-modal-help') {
        // this.lock = false
        // this.speed = 1
      }else{
        if(this.refillDone) {
          this.lock = false
          this.speed = 1
        }
      }
    },
    onRefill() {
      this.$refs.timerTop.setAttribute('data-active', '')
      this.refillDone = true
      if(!this.modalOpen) {
        this.lock = false
        this.speed = 1
      }
    },
    onModal(id) {
      if(id === 'main-modal-help') {
        this.lock = true
        this.speed = 0
        this.$modal.show('main-modal-help');
      } else if(data[`s${id}`]) {
        // if(id === 3){
        //   this.short = true
        //   setTimeout(() => {
        //     this.onRefill()
        //   }, 100);

        // }else{

          this.$refs.timerTop.setAttribute('data-active', 'refueling')
          // if(this.$isMob) {
            // this.$refs.Status.progress();
          // }else{
            let idInterval = setInterval(()=>{
              if(this.pers < 0) {
                this.pers++
              }else{
                this.onRefill()
                this.pers = -100
                clearInterval(idInterval)
              }
            },80)
          // }

        // }
        this.refillDone = false
        this.modalContent = data[`s${id}`];
        this.modalContent.id = `s${id}`;
        this.$modal.show('main-modal');
      }
    },
    onUpDown(toUp) {
      toUp? this.onUp() : this.onDown()
    },
    onUp(){
      if(this.lock) {return}
      if(this.speed < this.speedMax) {
        this.moving = true
        this.stoped = false
        this.speed++
      }
    },
    onDown() {
      if(this.lock) {return}
      if(this.speed > this.speedMin) {
        this.moving = true
        this.stoped = false
        this.speed--
      }
    },
    keyEvents() {
      document.body.addEventListener('keydown', (e)=>{
        if(e.keyCode === 32) { // code - Space, keyCode - 32
          console.log('Space');
          this.$modal.hide('main-modal-help');
          if(this.pers === -100) {
            this.$modal.hide('main-modal');
          }
        }
        if(e.key === 'ArrowUp') {
          this.onUp()
        }
        if(e.key === 'ArrowDown') {
          this.onDown()
        }
      })
    },
    setFishContainer(shipsContainer) {
      let posCenter = this.width / 5
      this.fishContainer.x = this.$isMob ? 20 : posCenter / 1.2
      this.fishContainer.children.forEach( el => {
        el.scale = {x: this.scale, y: this.scale}
      })
      // 0-рыбы, 1-рыбы, 2-рыбы, 3-рыбы, 4-кит, 5-кит
      this.fishContainer.children[4].x = this.$isMob ? 20 : (this.width / 8)
      this.fishContainer.children[5].x = this.$isMob ? 20 : (this.width / 8)

      this.fishContainer.children[0].y = shipsContainer[0].y + this.height / 5
      this.fishContainer.children[4].y = shipsContainer[0].y - this.height / 1.5
      this.fishContainer.children[1].y = shipsContainer[1].y - this.height / 2
      this.fishContainer.children[2].y = shipsContainer[3].y - this.height / 2
      this.fishContainer.children[3].y = shipsContainer[4].y - this.height / 2
      this.fishContainer.children[5].y = shipsContainer[2].y - this.height * 1.5 // / 1.5
    },
    setbgElContainerConf(shipsContainer) {
      let scale = this.$isMob ? (this.scale - 0.05) : this.scale
      this.bgElContainer.lighthouse = this.bgElContainer.children[0]
      this.bgElContainer.mermaid = this.bgElContainer.children[1]
      this.bgElContainer.submarine = this.bgElContainer.children[2]
      this.bgElContainer.gollandec = this.bgElContainer.children[3]
      this.bgElContainer.treasureIsland = this.bgElContainer.children[4]
      this.bgElContainer.shipLIHUE = this.bgElContainer.children[5]
      this.bgElContainer.lighthouse.scale = { x: scale, y: scale}
      this.bgElContainer.mermaid.scale = { x: scale, y: scale}
      this.bgElContainer.submarine.scale = { x: scale, y: scale}
      this.bgElContainer.gollandec.scale = this.$isMob ? { x: scale + 0.02, y: scale + 0.02} : { x: scale, y: scale}
      this.bgElContainer.treasureIsland.scale = { x: scale, y: scale}
      this.bgElContainer.shipLIHUE.scale = this.$isMob ? { x: scale + 0.02, y: scale + 0.02} : { x: scale, y: scale}

      this.bgElContainer.submarine.x = this.$isMob ? -10 : this.width / 7
      this.bgElContainer.lighthouse.x = this.$isMob ? -10 : this.width / 4.5
      this.bgElContainer.mermaid.x = this.$isMob ? -10 : this.width / 4.5
      this.bgElContainer.treasureIsland.x = this.$isMob ? -10 : this.width / 4.5

      this.bgElContainer.submarine.y = shipsContainer.children[2].y - (this.$isMob ? this.height / 3 : 400)
      this.bgElContainer.lighthouse.y = shipsContainer.children[3].y - (this.$isMob ? this.height / 2.5 : 400)
      this.bgElContainer.gollandec.y = shipsContainer.children[3].y - (this.$isMob ? this.height / 1.3 : 900)
      this.bgElContainer.shipLIHUE.y = shipsContainer.children[2].y - (this.$isMob ? this.height / 1.3 : 1400)
      this.bgElContainer.mermaid.y = shipsContainer.children[4].y - (this.$isMob ? this.height / 2 : 500)
      this.bgElContainer.treasureIsland.y = shipsContainer.children[5].y

      this.bgElContainer.gollandec.x = this.refuellerContainer.x + this.refuellerContainer.ship.height / 2.2
      this.bgElContainer.shipLIHUE.x = this.refuellerContainer.x + this.refuellerContainer.ship.height / 2.2

    },
    setRefuellerConf() {
      this.refuellerContainer.ship = this.refuellerContainer.children[1]
      this.refuellerContainer.ladder = this.refuellerContainer.children[0]
      // this.refuellerContainer.ladder.alpha = 0
      this.refuellerContainer.ladder.x = -20
      // ---
      this.refuellerContainer.y = this.$isMob? window.innerHeight / 3 : 400
      this.refuellerContainer.ladder.scale = {x: this.scale, y: this.scale}
      this.refuellerContainer.ship.scale = {x: this.scale, y: this.scale}
      this.refuellerContainer.x = this.$isMob ? this.width / 3.55 : this.width / 2.6
      this.refuellerContainer._height = this.refuellerContainer.getBounds().height
      this.refuellerContainer.ladder._height = this.refuellerContainer.ladder.getBounds().height
    },
    setShipsConf() {
      let shipsPosY = 0 //this.height * 0.9
      this.shipsContainer.children.forEach( (el, i) => {
        el._center = el._height / 2
        el.scale = {x: this.scale, y: this.scale}
        el.x = this.refuellerContainer.getBounds().x + this.refuellerContainer.ship.getBounds().width / 1.05
        el._height = el.getBounds().height

        if(i !== 0) {
          shipsPosY -= this.$isMob ? el._height + (this.height / 1.4) : el._height + 700 //(this.height / 1.4)
        }

        // делаем больше расстояние между корблями что бы нормально вставить с дымом
        if(i === 3) {
          shipsPosY = this.$isMob ? shipsPosY - this.height / 1.3 : shipsPosY - 1500
        }
        // делаем больше расстояние между корблями что бы нормально вставить голландца
        if(i === 4) {
          shipsPosY = this.$isMob ? shipsPosY - this.height / 1.3 : shipsPosY - 1000
        }
        // Двигаем бальше последний корабль
        if(i === 5) {
          shipsPosY = this.$isMob ? shipsPosY - this.height / 1.3 : shipsPosY - 300
        }

        el.y = shipsPosY
      })
      this.shipsContainer.children[1].scale = this.$isMob ? { x: this.scale - 0.025, y: this.scale - 0.025} : { x: this.scale, y: this.scale}
      this.shipsContainer.children[3].x = this.shipsContainer.children[3].x - (this.$isMob ? 0 : 0)
      this.shipsContainer.children[3].scale = this.$isMob ? { x: this.scale - 0.025, y: this.scale - 0.025} : { x: this.scale, y: this.scale}
      this.shipsContainer.children[3].x = this.shipsContainer.children[3].x - 2
      this.shipsContainer.children[4].x = this.shipsContainer.children[4].x - 2
    },
    setAreaConf(shipsCont) {
      if(!shipsCont) return;
      this.areaContainer.children.forEach( (el, i) => {
        el.x = this.refuellerContainer.getBounds().x / 1.02
        el.scale = {x: this.scale, y: this.scale}
        el.y = (shipsCont[i].y + shipsCont[i].height / 2) - el.height / 2

        if(i === 0) {
          el.x = el.x - 10;
          el.scale = {x: this.scale + 0.03, y: this.scale + 0.03};
          el.y = (shipsCont[i].y + shipsCont[i].height / 2) - el.getBounds().height / 2
        }
        el._height = el.getBounds().height
      })
    },
    setPierConf(shipsCont) {
      this.pierContainer.children.forEach( (el, i) => {
        el.scale = this.$isMob ? {x: this.scale, y: this.scale} : {x: this.scale + 0.05, y: this.scale + 0.05}
        el.y = (shipsCont[i].y + shipsCont[i].height / 2) - el.height / 2
      })
      this.pierContainer.x = this.$isMob ? this.width / 1.5 : this.width / 1.84
    },
    init() {
      // let width = 1200;
      // let height = 800;
      let clodRatio = 347 / 1000;
      this.scale = this.$isMob ? 0.19 : 0.285
      let sp = 0

      // ---------------------------
        const createContainer = (list) => {
          let cont = new PIXI.Container();
          list.forEach(name => cont.addChild(PIXI.Sprite.from(name)) )
          return cont;
        }
      // ---------------------------
      let i = 0
      let flag = true
      let dirDown = true
      const update = (y) => {
        if(flag) { i = 0 }
        if(dirDown){
          if(i <= 1) {
            y = y + Math.pow(1 - i, 2) / 2;
            i += 0.002
            if(i >= 0.4) {
              this.moving = false
            }
            if(i >= 0.6) {
              this.speedLast = 0
              this.stoped = true
            }
          }
        }else{
          if(i >= -1) {
            y = y - Math.pow(1 + i, 2) / 2;
            i -= 0.002
            if(i <= -0.4) {
              this.moving = false
            }
            if(i <= -0.6) {
              this.speedLast = 0
              this.stoped = true
            }
          }
        }
        flag = false
        return y
      }
    
    // ------ debug
    // ---------------------------
      let conf = {
        width: (window.innerWidth > 1920 ? 1920 : this.width),
        height: this.height,
        view: this.$refs.game,
        backgroundColor: '0x062d3c', // red '0xFF0000',
      }
      if (window.devicePixelRatio > 1) {
        conf.resolution = 2;
        conf.autoDensity = true;
        conf.antialias = false;
      }
      if(window.innerWidth <= 1920) {
        conf.resizeTo = window;
      }

      const app = new PIXI.Application(conf);
      const loader = PIXI.Loader.shared;
      const shipFiles = [
        'ship_Atair.png',
        'ship_Containership.png',
        'ship_Ledokol.png',
        // 'ship_LIHUE.png', // обманка
        'ship_Liner.png',
        'ship_Buksir.png',
        // '', // обманка
        'ship_Cementovoz.png',
      ]
      const setup = (loader, resources) => {

        let bg = new PIXI.TilingSprite(resources[(this.$isMob ? 'bg_mob.jpg' : 'bg.jpg')].texture);
        this.bgElContainer = createContainer(['Lighthouse.png', 'mermaid.png', 'Submarine.png', 'Gollandec.png', 'treasure_Island.png', 'ship_LIHUE.png']);
        this.sledForward = new PIXI.Sprite(resources['ship0sf.png'].texture);
        this.sledBackward = new PIXI.Sprite(resources['ship0sb.png'].texture);
        this.fishContainer = createContainer(['fish1.png', 'fish1.png', 'fish1.png', 'fish1.png', 'whale.png', 'whale.png']);
        let ice = new PIXI.TilingSprite(resources['ice.png'].texture, this.width, this.height);
        let clouds = new PIXI.TilingSprite(resources['clouds1.png'].texture);
        let lockTotalSprite = new PIXI.TilingSprite(resources['lockTotal.png'].texture);
        this.refuellerContainer = createContainer(['ship0a.png', 'ship0.png'])
        this.shipsContainer = createContainer(shipFiles)
        this.pierContainer = createContainer(Array(shipFiles.length).fill('Prichal.png'))
        this.areaContainer = createContainer(Array(shipFiles.length).fill('shipLine.png'))

        this.setRefuellerConf()
        this.setShipsConf()
        this.setAreaConf(this.shipsContainer.children)
        this.setPierConf(this.shipsContainer.children)

        // -----------

        app.stage.addChild(
          bg,
          this.fishContainer,
          ice,
          this.bgElContainer,
          this.sledForward,
          this.sledBackward,
          this.areaContainer,
          this.refuellerContainer,
          this.shipsContainer,
          this.pierContainer,
          clouds,
          lockTotalSprite,
        );

        // --------------
        let offset = 700;

        const calcCollision = (id) => {
          let cntr0 = Math.round(this.refuellerContainer.y + this.refuellerContainer._height / 2);
          const sh0 = this.refuellerContainer.ladder
          let sh1 = this.areaContainer.children[id]
          if(!sh1) {return}
          let sh1Completed = false
          const sh1Cntr = sh1.getGlobalPosition().y + sh1._height / 2;
          let offsetStop = sh1._height - sh0._height

          if(id === 0) {
            offsetStop = offsetStop / 1.8
          }

          // --- Debug
          // if(id === this.score) {
          //   rectangle0.y = sh1Cntr + offsetStop
          //   rectangle1.y = sh1Cntr - offsetStop
          //   rectangle2.y = cntr0
          // }

          // Проверяем что корабль не уплыл дальше запретной зоны
          // lockTotalSprite.alpha = 0
          if(id === this.score) {
            lockTotalSprite.y = sh1Cntr - 400 - lockTotalSprite.height - sh0.height / 2 // - lockTotal.height - sh0.height //bg.tilePosition.y
            if(id === this.score && cntr0 < sh1Cntr - 400) {
              this.lockTotal = true
            }else if(this.lockTotal){
              this.lockTotal = false
            }
          }

          if(sh1Cntr + offset > cntr0 && sh1Cntr - offset < cntr0) {

            // Показываем или скрываем линию
            // if(sh1Cntr + 300 > cntr0 && sh1Cntr - 250 < cntr0) {
            //   sh1.visible = true
            // }else{
            //   sh1.visible = false
            // }

            // console.log(Math.round(sh1Cntr + offsetStop), cntr0);
            // Показываем или скрываем трап
            // if(sh1Cntr + offsetStop > cntr0 && sh1Cntr - offsetStop < cntr0) {
            if(sh1Cntr + offsetStop > cntr0 && sh1Cntr - offsetStop < cntr0 && this.stoped) {
              // console.log(
              //   Math.round(sh1Cntr) , Math.round(cntr0), offsetStop
              // );
              if(sh0.alpha === 0 && !sh1Completed) {
                sh0.alpha = 1
                sh1Completed = true
                this.completed(id)
              }
            }else if(sh0.alpha === 1){
              // console.log(1.2);
              sh0.alpha = 0
            }

            // Показываем если близко
            if(!sh1.visible) {
              sh1.visible = true
            }
          }else{
            // Скрываем если корабль далеко
            if(sh1.visible) {
              sh1.visible = false
              sh1.visible = false
            }
          }
        }
        // --------------
        const resize = () => {
          this.width = window.innerWidth > 1920 ? 1920 : window.innerWidth
          this.height = window.innerHeight

          this.scale = this.width < 1920 ? (0.00017 * this.width) : this.scale
          this.scale = this.$isMob ? 0.19 : this.scale

          lockTotalSprite.width = this.width
          lockTotalSprite.height = this.height

          if(this.$isMob) {
            bg.width = 1400
            bg.height = 4706
            bg.tileScale = {x: (this.width / bg.width), y: (this.width / bg.width)}
          }else{
            bg.width = 1920
            bg.height = 4800
            bg.tileScale = {x: (this.width / bg.width), y: (this.width / bg.width)}
          }

          if(this.$isMob) {
            clouds.visible = false
          }else{
            clouds.width = this.width //1920
            clouds.height = this.height //1080
            clouds.tileScale = {x: (this.width / bg.width), y: (this.width / bg.width)}
          }

            // clouds1.alpha = 0.1
            // clouds2.alpha = 0.1
          // }
          let posCenter = this.refuellerContainer.x - this.refuellerContainer._height

          ice.width = 260
          ice.x = this.$isMob ? -200 : posCenter / 1.1

          lockTotalSprite.x = 0
          lockTotalSprite.y = 0
          // -------
          this.setRefuellerConf()
          this.setShipsConf()
          this.setPierConf(this.shipsContainer.children)
          this.setAreaConf(this.shipsContainer.children)
          this.setFishContainer(this.shipsContainer.children)  
          this.setbgElContainerConf(this.shipsContainer)
          // -------

          this.sledForward.y = this.refuellerContainer.y
          this.sledForward.x = this.refuellerContainer.x + 5
          this.sledForward.scale = {x: this.scale, y: this.scale}

          this.sledBackward.y = this.refuellerContainer.y - this.refuellerContainer._height + 100
          this.sledBackward.x = this.refuellerContainer.x + 12
          this.sledBackward.scale = {x: this.scale, y: this.scale}
          this.sledForward.alpha = 0
          this.sledBackward.alpha = 0

        }
        app.renderer.on('resize', resize );
        resize();

        // --------------
        debug.init(app, this.shipsContainer);
        // --------------
        let bgPosLast = 1
        app.ticker.add((delta) => {
          if(this.finish) {
            if(this.refuellerContainer.y > -500) {
              if(this.refuellerContainer.ladder.alpha !== 0) {
                this.refuellerContainer.ladder.alpha = 0
              }
              this.refuellerContainer.y += delta * sp * 3;
              this.sledForward.y = this.refuellerContainer.y + this.refuellerContainer._height - 20
            }else{
              this.refuellerContainer.visible = false
              this.sledForward.visible = false
            }
            return
          }

          if(!this.lock) {
            this.timer++;
          }
          this.timerStr = timeCounter(this.timer);

          let lihueStart = (this.bgElContainer.children[5].getBounds().y - 50)
          let lihueEnd = (this.bgElContainer.children[5].getBounds().y + this.bgElContainer.children[5].height + 100)

          let gollandecStart = (this.bgElContainer.children[3].getBounds().y - 50)
          let gollandecEnd = (this.bgElContainer.children[3].getBounds().y + this.bgElContainer.children[3].height + 100)

          let mermaidStart = this.bgElContainer.mermaid.getBounds().y - 50
          let mermaidEnd = this.bgElContainer.mermaid.getBounds().y + this.bgElContainer.mermaid.height + 100

          let shipEnd = 0
          let shipStart = 0
          if(this.areaContainer.children[this.score]) {
            shipEnd = this.areaContainer.children[this.score].getBounds().y + this.areaContainer.children[this.score].height
            shipStart = this.areaContainer.children[this.score].getBounds().y - 100
          }else{
            shipEnd = 1000
            shipStart = 1000
          }
          // Проверяем что корабль не вышел за границы. 
          if(this.lockTotal && this.speed >= 0) {
            if(this.notify !== 2) {
              this.notify = 2
            }
            this.speedLast = 0
            this.speed = 0
            return
          }else if(lihueEnd > this.refuellerContainer.y && lihueStart < this.refuellerContainer.y) {
            if(this.notify !== 6) {
              this.notify = 6
            }
          }else if(gollandecEnd > this.refuellerContainer.y && gollandecStart < this.refuellerContainer.y) {
            if(this.notify !== 3) {
              this.notify = 3
            }
          }else if(mermaidEnd > this.refuellerContainer.y && mermaidStart < this.refuellerContainer.y) {
            if(this.notify !== 4) {
              this.notify = 4
            }
            // швартоваться правым бортом
          }else if(shipEnd > this.refuellerContainer.y && shipStart < this.refuellerContainer.y) {
            if(this.notify !== 5) {
              this.notify = 5
            }
            // вижу на горизонте
          }else if(shipEnd + 600 > this.refuellerContainer.y && shipStart < this.refuellerContainer.y) {
            if(this.notify !== 1) {
              this.notify = 1
            }
          }else if(this.notify !== 0) {
            this.notify = 0
          }

          if((bg.tilePosition.y - bgPosLast) > 0) {
            if(this.sledBackward.alpha !== 0) { this.sledBackward.alpha = 0}
            this.sledForward.alpha = (bg.tilePosition.y - bgPosLast);
          }else{
            if(this.sledForward.alpha !== 0) { this.sledForward.alpha = 0}
            this.sledBackward.alpha = Math.abs(bg.tilePosition.y - bgPosLast)
          }
          
          this.fishContainer.y  = bg.tilePosition.y
          this.bgElContainer.y = bg.tilePosition.y - 100
          bgPosLast = bg.tilePosition.y
          // -------------- Debug
          // throttleCalc();
          // let _cntr1 = areaContainer.children[0].getGlobalPosition().y + areaContainer.children[0]._height / 2
          // let _offset = (areaContainer.children[0]._height - refuellerContainer._height)
          // rectangle1.y = cntr0 - _offset
          // rectangle2.y = _cntr1;

          debug.ticker(this);

          // --------------
          calcCollision(this.score)
          // --------------

          if(this.speed === 0 || (this.moving && this.speed < 0 && this.speedLast > 0) || (this.moving && this.speed > 0 && this.speedLast < 0)) {
            let pos = update(bg.tilePosition.y)
            let posCloud = update(clouds.tilePosition.y)
            bg.tilePosition.y = pos
            this.shipsContainer.y = pos
            // sledForward.y = refuellerContainer.y + refuellerContainer._height
            this.pierContainer.y = pos
            this.areaContainer.y = pos
            ice.tilePosition.y = pos
            clouds.tilePosition.y = posCloud
            return
          }
          if(this.speed === 1) {sp = -0.6; flag = true; dirDown = true}
          if(this.speed === 2) {sp = -1.8; flag = true; dirDown = true}
          if(this.speed === 3) {sp = -4.0; flag = true; dirDown = true}
          if(this.speed === -1) {sp = 0.4; flag = true; dirDown = false}
          if(this.speed === -2) {sp = 1.6; flag = true; dirDown = false}

          bg.tilePosition.y -= delta * sp;
          ice.tilePosition.y -= delta * sp;

          // this.yPos = Math.round(this.fishContainer.y)

          this.shipsContainer.y -= delta * sp;
          // sledForward.y = refuellerContainer.y + refuellerContainer._height

          if(this.speed === -2) { this.sledBackward.y = this.refuellerContainer.y - this.refuellerContainer._height + 100 }
          if(this.speed === -1) { this.sledBackward.y = this.refuellerContainer.y - this.refuellerContainer._height + 100 }
          if(this.speed === 1) { this.sledForward.y = this.refuellerContainer.y + this.refuellerContainer._height - 100 }
          if(this.speed === 2) { this.sledForward.y = this.refuellerContainer.y + this.refuellerContainer._height - 50 }
          if(this.speed === 3) { this.sledForward.y = this.refuellerContainer.y + this.refuellerContainer._height - 20 }

          this.pierContainer.y -= delta * sp;
          this.areaContainer.y -= delta * sp;

          clouds.tilePosition.y -= delta * sp + 0.3;
          if(this.speed !== 0) { this.speedLast = this.speed }
        });
      };

      loader.baseUrl = this.$server;
      loader
        .add([
          (this.$isMob ? 'bg_mob.jpg' : 'bg.jpg'),
          'ice.png',
          'clouds1.png',
          'ship0.png',
          'ship0a.png',
          'ship0sf.png',
          'ship0sb.png',
          'shipLine.png',
          'Prichal.png',
          'Lighthouse.png',
          'mermaid.png',
          'Submarine.png',
          'ship_LIHUE.png',
          'Gollandec.png',
          'treasure_Island.png',
          'whale.png',
          'fish1.png',
          'lockTotal.png',
          ...shipFiles
        ]).load(setup);

      loader.onProgress.add((e) => {
        // console.log(e.progress);
        this.progress = e.progress
      });
      loader.onComplete.add(() => {
        // let preloader = document.querySelector('.sip_canvas_preloader');
        // preloader.classList.add('sip_canvas_preloader_loaded');
        // setTimeout(() => {
        //   preloader.style.display = 'none'
        //   this.$modal.show('main-modal-help');
        // }, 300);
      });
    }
  }
}
</script>

<style lang="stylus" src="./GamePIXI.styl" />
